export enum RoomCategory {
    YOURCHAT = "本人",
    FAMILY = "家族・親族",
    DAI = "利用者本人",
    STAFF = "職員",
    EXTERNAL = "外部の関係者",
    GROUP = "グループ",
    SELFCHAT = "自分のトークルーム"
}

export enum MediaSharedLinkType {
    VIDEO = "video",
    IMAGE = "image"
}